import { Ref, computed } from '@vue/composition-api';
import { AcoFormData, AdgroupFormData, CreativeConfig, FullNormalFormData, PixelInfo } from '@tt4b/ttam-enums';
import { useCreativeActionTypeIs, usePixelInfoApi } from '@tt4b/ttam-hooks';
import { PixelType } from '@ad/tt_ads_common_enums';

export function useWebsiteEvents(opt: {
  adGroupPixelInfo: Ref<PixelInfo>;
  copyNum: Ref<number>;
  adgroupData: Ref<AdgroupFormData>;
  creativeConfig: Ref<CreativeConfig>;
  createMode: Ref<string>;
  creativeData: Ref<Partial<FullNormalFormData & AcoFormData>>;
  aadvid: Ref<string>;
}) {
  const { adgroupData, adGroupPixelInfo, creativeConfig, createMode, creativeData, copyNum, aadvid } = opt;

  // ad group对应的pixel name
  const pixelLabel = computed(() => {
    const pixelId = adgroupData.value?.adRefPixelId;
    if (!pixelId) {
      return '-';
    }

    return adGroupPixelInfo.value?.name;
  });

  const addPixelLink = computed(() => `${window.location.origin}/i18n/events_manager/pixel?aadvid=${aadvid.value}`);

  const disabled = computed(() => creativeConfig.value.disableAll);

  const isOffSitePixel = computed(() => adgroupData.value?.adRefPixelId && adGroupPixelInfo.value?.isOnSite === false);

  const { isCreate, isEdit, isCopy } = useCreativeActionTypeIs({
    createMode,
    adgroupFormData: adgroupData,
  });
  const isPixelItemDisabled = (i: PixelInfo) => {
    if (isCreate.value) {
      return i.availableQuota < 1;
    } else if (isEdit.value) {
      return i.id !== creativeData.value?.trackingPixelId && i.availableQuota < 1;
    } else if (isCopy.value) {
      return i.availableQuota < copyNum.value;
    }

    return false;
  };

  const getCurrentPixelInfo = () =>
    usePixelInfoApi({
      pixelId: creativeData.value?.trackingPixelId,
      promotionWebsiteType: PixelType.EXTERNAL_WEBSITE, // Creative 选的 Website events 都是 EXTERNAL_WEBSITE 类型
    });

  return {
    disabled,
    pixelLabel,
    isOffSitePixel,
    addPixelLink,
    isPixelItemDisabled,
    getCurrentPixelInfo,
  };
}
